module.exports = __webpack_public_path__ + "img/furniture-fr.4c779555.svg";